import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdReceipt, MdDashboard, MdBarChart, MdTrendingUp } from 'react-icons/md';
import TransactionsOverview from './TransactionsOverview';
import TransactionsStatistics from './TransactionsStatistics';
import TransactionsProgress from './TransactionsProgress';
import PeriodSelectBox from '../../global/PeriodSelectBox';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import TabBar from '../../../shared/layout/tabs/TabBar';
import TabButton from '../../../shared/layout/tabs/TabButton';

const Transactions = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('overview');
    const [selectedPeriod, setSelectedPeriod] = useState('last_7_days');

    const handlePeriodChange = (e) => setSelectedPeriod(e.target.value);

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle icon={<MdReceipt size={28} />}>{t('Transactions.title')}</PageTitle>
                <PeriodSelectBox value={selectedPeriod} onChange={handlePeriodChange} />
            </PageHeader>

            <PageContent>
                <TabBar>
                    <TabButton
                        active={activeTab === 'overview'}
                        onClick={() => setActiveTab('overview')}
                        icon={<MdDashboard />}
                    >
                        {t('Transactions.overview')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'statistics'}
                        onClick={() => setActiveTab('statistics')}
                        icon={<MdBarChart />}
                    >
                        {t('Transactions.statistics')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'progress'}
                        onClick={() => setActiveTab('progress')}
                        icon={<MdTrendingUp />}
                    >
                        {t('Transactions.progress')}
                    </TabButton>
                </TabBar>

                <div style={{ marginTop: '24px' }}>
                    {activeTab === 'overview' && <TransactionsOverview period={selectedPeriod} />}
                    {activeTab === 'statistics' && <TransactionsStatistics period={selectedPeriod} />}
                    {activeTab === 'progress' && <TransactionsProgress period={selectedPeriod} />}
                </div>
            </PageContent>
        </PageContainer>
    );
};

export default Transactions;


